import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=c9cf24fc&scoped=true"
import script from "./InventoryManagement.vue?vue&type=script&lang=js"
export * from "./InventoryManagement.vue?vue&type=script&lang=js"
import style0 from "./InventoryManagement.vue?vue&type=style&index=0&id=c9cf24fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cf24fc",
  null
  
)

export default component.exports